import { useEffect, useState } from "react";

interface ErrorPageProps {
  message: string;
}

function ErrorPage({ message }: ErrorPageProps) {
  const [isBackButtonDisabled, setIsBackButtonDIsabled] = useState<boolean>(true);

  useEffect(() => {
    setIsBackButtonDIsabled(window.history.length <= 1);
  }, []);

  return (
    <div className="home-container">
      <div className="error-message">
        <p>{message}</p>
        <button onClick={() => window.history.back()} disabled={isBackButtonDisabled}>
          Retour
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;
